import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FeedReadPositionEnabled extends BaseOption {
  static userInterfaceComponent = {
    label: "Where they left off",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    descriptionMessage:
      "Show a separator above the first row the viewer has not read yet, and open the feed there.",
    props: {
      options: [
        { label: "On", value: true, tooltip: "" },
        { label: "Off", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = false;
}
